import React, { useEffect, useState } from "react";
import CustomSelectProductCategory from "../../components/CustomSelectProductCategory/CustomSelectProductCategory";
import UserProductAndSubProductFormLayout from "../../layouts/UserProductAndSubProductFormLayout";
import { useIntl } from "react-intl";
import {
  getLocalizedMessage,
  getValueOnCondition,
} from "../../UtilityFunctions/utils";
import { Text } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";

const UserProductAndSubProductFormContainerStyle = {
  headingStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    color: variables.textDefault,
  },
  middleSectionStyle: {
    marginBottom: variables.marginMediumSmall,
    marginTop: variables.marginMedium,
  },
  roleNameStyle: {
    color: variables.textDefault,
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightBold,
    lineHeight: variables.lineHeightSmall,
  },
};

export default function UserProductAndSubProductFormContainer({
  // NOSONAR
  roleName,
  productSubProductsOptions,
  setSelectedProductAndSubProductOptions,
}) {
  const intl = useIntl();
  const [searchProduct, setSearchProduct] = useState("");
  const [searchSubProduct, setSearchSubProduct] = useState("");
  const [lastProductSelected, setLastProductSelected] = useState("");

  useEffect(() => {
    if (productSubProductsOptions.length > 0)
      setLastProductSelected((prev) =>
        getValueOnCondition({
          condition: prev === "",
          trueValue: productSubProductsOptions[0].id,
          falseValue: prev,
        })
      );
  }, [productSubProductsOptions]);

  const filteredAllProducts = productSubProductsOptions?.filter((product) =>
    product.productCategoryName
      .toLowerCase()
      .includes(searchProduct.toLowerCase())
  );

  const handleProductCheck = (productId) => () => {
    setLastProductSelected(productId);
    setSelectedProductAndSubProductOptions((prev) =>
      prev.map((product) =>
        product.id === productId
          ? {
              ...product,
              checked: !product.checked,
              subCategory: product.subCategory.map((subCategoryProduct) => ({
                ...subCategoryProduct,
                checked: !product.checked,
              })),
            }
          : product
      )
    );
  };

  const productItemClick = (productId) => () => {
    setLastProductSelected(productId);
  };

  const handleSubProductCheck = (subProductId) => () => {
    //NOSONAR
    setSelectedProductAndSubProductOptions((prev) =>
      prev.map((product) => {
        let uncheck = false;
        return product.id === lastProductSelected
          ? {
              ...product,
              subCategory: product.subCategory.map((subCategoryProduct) => {
                uncheck =
                  uncheck ||
                  (subCategoryProduct.id === subProductId
                    ? !subCategoryProduct.checked
                    : subCategoryProduct.checked);
                return getValueOnCondition({
                  condition: subCategoryProduct.id === subProductId,
                  trueValue: {
                    ...subCategoryProduct,
                    checked: !subCategoryProduct?.checked,
                  },
                  falseValue: subCategoryProduct,
                });
              }),
              checked: uncheck,
            }
          : product;
      })
    );
  };

  const optionSubProducts =
    lastProductSelected &&
    productSubProductsOptions?.find(
      (product) => product.id === lastProductSelected
    );

  const filteredSubProducts = optionSubProducts?.subCategory?.filter(
    (product) =>
      product.name.toLowerCase().includes(searchSubProduct.toLowerCase())
  );

  return (
    <UserProductAndSubProductFormLayout
      topSection={
        <Text style={UserProductAndSubProductFormContainerStyle.roleNameStyle}>
          {roleName}
        </Text>
      }
      middleSection={
        <Text style={UserProductAndSubProductFormContainerStyle.headingStyle}>
          {getLocalizedMessage(
            intl,
            "addUser.text.categoryProductAndSubProduct"
          )}
        </Text>
      }
      middleSectionStyle={
        UserProductAndSubProductFormContainerStyle.middleSectionStyle
      }
      leftBottomSection={
        <CustomSelectProductCategory
          options={filteredAllProducts}
          placeholder={getLocalizedMessage(
            intl,
            "searchProducts.placeholder.searchProductCategory"
          )}
          setSearchTerm={setSearchProduct}
          handleProductCheck={handleProductCheck}
          onItemSelect={productItemClick}
          isCheckboxVisible={true}
          showRightArrows={true}
          lastProductSelected={lastProductSelected}
        />
      }
      rightBottomSection={
        <CustomSelectProductCategory
          options={filteredSubProducts || []}
          placeholder={getLocalizedMessage(
            intl,
            "searchSubProducts.placeholder.searchSubProductCategory"
          )}
          setSearchTerm={setSearchSubProduct}
          handleProductCheck={handleSubProductCheck}
          onItemSelect={() => {}} //NOSONAR
          isCheckboxVisible={true}
          showRightArrows={false}
        />
      }
    />
  );
}
